import styled from 'styled-components';

interface Props {
  isOver?: boolean;
}

export const StyledOrderDropZone = styled.div<Props>`
  /* background-color: ${props => props.isOver ? 'lightblue' : 'peachpuff'}; */
  padding: 40px 0px;
`;